'use client';

import { createContext, useState, useContext } from 'react';

const BannerContext = createContext();

const BannerProvider = ({ children }) => {
  const [education, setEducation] = useState(null);
  const [headerHeight, setHeaderHeight] = useState(56); // Default header height without banner

  return (
    <BannerContext.Provider value={{ education, setEducation, headerHeight, setHeaderHeight }}>
      {children}
    </BannerContext.Provider>
  );
};

const useBanner = () => useContext(BannerContext);

export { BannerProvider, useBanner };
